import {
  StyledCard,
  CardHeader,
  TitleContainer,
} from '../../../components/Dashboard/styles/MindmapTableStyles'
import { SkeletonBox } from '../styles/SkeletonStyles'
import { SPACING, BORDER_RADIUS } from '../../../styles/theme'

export function SkeletonProjectCard() {
  return (
    <StyledCard>
      <CardHeader>
        <TitleContainer>
          <SkeletonBox $width="70%" $height="24px" style={{ marginBottom: SPACING.xs }} />
          <SkeletonBox $width="45%" $height="20px" />
        </TitleContainer>
        <SkeletonBox $width="32px" $height="32px" $radius={BORDER_RADIUS.md} />
      </CardHeader>
    </StyledCard>
  )
}
